<template>
<div class="ti">
  <div>
    <el-button size="mini" type="primary text2"  @click="modals" v-if="userJid[1]['id']==4001002">添加业主</el-button>
    <el-select size="mini" v-model="value" filterable placeholder="请选择组织" class="kuan" v-if="userJid[0]['id']==4001001">
      <el-option
        key=""
        label="全部"
        value="">
      </el-option>
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.company_name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-input size="mini" class="search" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
  </div>
  <v-divider></v-divider>
  <v-simple-table :height="__TABLE_HEIGHT__">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">ID</th>
            <th class="text-left">业主姓名</th>
            <th class="text-left">身份证</th>
            <th class="text-left">手机号</th>
            <th class="text-left">日期</th>
            <th class="text-left">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text1" v-for="item in desserts" :key="item.id">
            <td >{{item.id}}</td>
            <td >{{item.name}}</td>
            <td >{{item.identification_card}}</td>
            <td >{{item.phone}}</td>
            <td >{{item.date}}</td>
            <td >
              <v-icon style="color: #1867c0;" @click="xiugai( item.id )" v-if="userJid[2]['id']==4001003">mdi-pencil</v-icon>
              <v-icon  style="color: red;" @click="del( item.id )" v-if="userJid[3]['id']==4001004">mdi-pail-outline</v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-divider></v-divider>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="800"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  label-width="80px" :model="dades">
            <el-form-item label="业主姓名" :rules="[{required: true}]">
              <el-input v-model="dades.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证" :rules="[{required: true}]">
              <el-input v-model="dades.identification_card"></el-input>
            </el-form-item>
            <el-form-item label="电话" :rules="[{required: true}]">
              <el-input v-model="dades.phone"></el-input>
            </el-form-item>
            <el-form-item label="性别" :rules="[{required: true}]">
              <el-input v-model="dades.gender"></el-input>
            </el-form-item>
            <el-form-item label="所属组织" :rules="[{required: true}]">
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-if="cs == 2" disabled @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="dades.company_id" filterable placeholder="请选择" v-else @change="changesa(dades.company_id)">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.company_name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属项目" :rules="[{required: true}]">
              <el-select v-model="dades.pindex_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in opdade"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      defaultcheckedkeys:[],
      defaultcheckedkeyssa:[],
      dades: {
        id:'',
        name:'',
        identification_card:'',
        phone: '',
        company_id: '',
        pindex_id:'',
        gender:'',
      },
       options: [
        {
          value: '',
          label: ''
        },],
        options1: [
        {
          value: '',
          label: ''
        },],
        opdade:[],
      options2:[],
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
    }
  },
  //界面没出来前加载
  created() {
    this.userJid = [{id:''},{id:''},{id:''},{id:''}];
    this.$myhttp.get('admin/lavel3?pid=4001',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // console.log(backdata.data);
        if(backdata.data != 1){
          var date = backdata.data;
          date.forEach(item => {
            //本界面权限
            if(item.id == 4001001){
              this.userJid[0]['id'] = item.id;
            }
            if(item.id == 4001002){
              this.userJid[1]['id'] = item.id;
            }
            if(item.id == 4001003){
              this.userJid[2]['id'] = item.id;
            }
            if(item.id == 4001004){
              this.userJid[3]['id'] = item.id;
            }
          });
        }else{
          //本界面权限
          this.userJid = [{id:'4001001'},{id:'4001002'},{id:'4001003'},{id:'4001004'}];
        }
        // console.log(this.userJid)
      });
  },
  // 加载数据
  mounted(){
    var t = Date.parse(new Date()) / 1000;//时间戳
    var login = window.localStorage.getItem('login');
    this.$myhttp.get('admin/getcompanygshu?login='+login,{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        // this.value1 = backdata.data[0];//开启不查全部
        this.value1 = 0;
        this.$myhttp.get('admin/userOwner?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.desserts = backdata.data[0];
            this.total = backdata.data[1];
            this.page = backdata.data[2];
        });
    });
    //加载公司列表和归属列表
    this.$myhttp.get('admin/getcompany',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.options = backdata.data[0];
        this.options1 = backdata.data[1];
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //监听选择组织改变归属
    changesa(e){
      this.$myhttp.get('admin/getuserOwner?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.opdade=backdata.data;
       this.$forceUpdate();
      });

    },
    //保存
    ok(){
      if(this.dades.name == ""){
        this.$Message.error('业主姓名不能为空!');
        return false;
      }
      if(this.dades.identification_card == ""){
        this.$Message.error('业主身份证不能为空!');
        return false;
      }
      if(this.dades.phone == ""){
        this.$Message.error('业主手机号不能为空!');
        return false;
      }
      if(this.dades.gender == ""){
        this.$Message.error('业主性别不能为空!');
        return false;
      }
      if(this.dades.company_id == ""){
        this.$Message.error('所属组织不能为空!');
        return false;
      }
      if(this.dades.company_id1 == ""){
        this.$Message.error('业主归属项目不能为空!');
        return false;
      }
      this.$myhttp.post('admin/userOwnerAdd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.$myhttp.get('admin/userOwner?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
              'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
                this.desserts = backdata.data[0];
                this.total = backdata.data[1];
                this.page = backdata.data[2];
            });
            this.$Message.success(backdata.data[1]);
            this.dades={
              id:'',
              name:'',
              identification_card:'',
              phone: '',
              company_id: '',
              pindex_id:'',
              gender:'',
            };
          }else{
            this.$Message.error('编辑失败!');
          }
      });
    },
    //弹窗添加
    modals(){
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={
          id:'',
          name:'',
          identification_card:'',
          phone: '',
          company_id: '',
          pindex_id:'',
          gender:'',
        };
      }
      //加载公司权限列表
      var login = window.localStorage.getItem('login');
      this.$myhttp.get('admin/getJlist?login='+login,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[1] == 2){
              this.data =  backdata.data[0];
          }
          this.cs = backdata.data[1];
          this.dades.company_id=backdata.data[3];
          if(this.dades.company_id){
             this.$myhttp.get('admin/getuserOwner?id='+this.dades.company_id,{
            'Content-Type': 'application/json'
              }).then(backdata=>{ // 异步执行成功后
              this.opdade=backdata.data;
              this.$forceUpdate();
            });
          }
      });
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      var t = Date.parse(new Date()) / 1000;//时间戳
      this.$myhttp.get('admin/userOwner?id='+ e + '&search='+ this.search +'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
      });
    },
    //搜索
    searchs(){
      this.$myhttp.get('admin/userOwner?search='+ this.search + '&id=1'+'&company='+this.value +'&company1='+this.value1,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
      });
    },
    //修改查询
    xiugai(e){
      this.anxiu="修改";
      this.$myhttp.get('admin/getuserOwnerUpdate?id='+e,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.dades = backdata.data[0][0];
          this.cs = backdata.data[1];
          this.dades.company_id = backdata.data[2];
          this.opdade=backdata.data[3];
          this.$forceUpdate();
          this.modal1 = true;
      });
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$myhttp.post('admin/userOwnerDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                var t = Date.parse(new Date()) / 1000;//时间戳
                this.$myhttp.get('admin/userOwner?id=1'+'&company='+this.value +'&company1='+this.value1+'&t='+t+"&distinguish=0",{
                  'Content-Type': 'application/json'
                  }).then(backdata=>{ // 异步执行成功后
                    this.desserts = backdata.data[0];
                    this.total = backdata.data[1];
                    this.page = backdata.data[2];
                    this.$Message.success('删除成功!');
                  });
              }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Operation/execl.vue